import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['index', 'poAmount']);
  const createExternalPO = `createExternalPO(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createExternalPO} {
      id
    }
  }
`;
};
